import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import CalendarPortal from './CalendarPortal';
import { useClickOutside } from '../../utils';
import { getEventSource, getActiveElement } from '../../utils/shadowDomUtils';
var CalendarWrapper = function CalendarWrapper(props) {
  var closeTrigger = props.closeTrigger,
    containerRef = props.containerRef,
    isOpen = props.isOpen;
  var ref = React.useRef(null);
  var hideOnClickOutside = function hideOnClickOutside() {
    var activeEle = getActiveElement();
    var inputEle = null;
    if (containerRef && containerRef.current) {
      inputEle = containerRef.current.querySelector('input');
    }
    if (isOpen || activeEle === inputEle) {
      closeTrigger === null || closeTrigger === void 0 ? void 0 : closeTrigger();
    }
  };
  useClickOutside({
    enabled: true,
    isOutside: function isOutside(event) {
      var eventSource = getEventSource(event);
      if (containerRef && containerRef.current && ref && ref.current) {
        var _containerRef$current, _ref$current;
        return !((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(eventSource)) && !((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(eventSource));
      }
      return false;
    },
    handle: hideOnClickOutside
  });
  return /*#__PURE__*/React.createElement(CalendarPortal, _extends({}, props, {
    popRef: ref
  }));
};
export default CalendarWrapper;